import React from 'react'

const Webhooks = () => {
  return (
    <>
      <h1>Webhooks</h1>
    </>
  )
}

export default Webhooks